// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb, Col, Container, Grid, Row, Stack } from 'rsuite';
import CustomTable from './CustomTable';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import { ViewActivitiesDate, clintActivityFormatTime } from '@/functions';
import './style.css';
import BuyerDrawer from './BuyerDrawer';
import ugr from '../../UGRoute';

export default function ViewActivitiesPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryParamValue = searchParams.get('code');
  const catalogueName = searchParams.get('catalogueName');
  const status = searchParams.get('status');
  const [clientActivityData, setClientActivityData] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedTableData, setSelectedTableData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      const data = await axios.get(
        `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${queryParamValue}`
      );
      setMetaData(data.data.meta);
      const mainData = data.data.data.map(item => ({ ...item.attributes, id: item.id }));
      setClientActivityData(mainData);
    };
    fetchData();
  }, []);

  return (
    <Container className="main">
      <Stack className="table-toolbar" justifyContent="space-between" alignItems="flex-end">
        <BreadcrumbItem catalogueName={catalogueName} status={status} />
      </Stack>
      <main className="table-toolbar main" style={{ padding: '0 0 10px 0' }}>
        <Cards clientActivityData={clientActivityData} />
        <section style={{ padding: '10px 0', backgroundColor: 'white' }}>
          <div className="title">
            <h3 className="title">Session Details</h3>
          </div>
          <CustomTable
            data={clientActivityData}
            page={page}
            setPage={setPage}
            meta={metaData}
            setDrawerOpen={setDrawerOpen}
            setSelectedTableData={setSelectedTableData}
          />
        </section>
      </main>
      {drawerOpen && (
        <BuyerDrawer close={() => setDrawerOpen(false)} selectedTableData={selectedTableData} />
      )}
    </Container>
  );
}

const BreadcrumbItem = ({ catalogueName, status }) => {
  return (
    <Stack direction="column" alignItems="flex-start">
      <h3 className="title">
        Activity on {catalogueName}{' '}
        <span className={status == 'inActive' ? 'inActive' : ''}>{status}</span>
      </h3>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={`/${ugr}/dashboard`}>Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/${ugr}/manageCatalogue`}>All Catalogues</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Buyer Activity</Breadcrumb.Item>
      </Breadcrumb>
    </Stack>
  );
};

const Cards = React.memo(({ clientActivityData }) => (
  <Grid fluid>
    <Row className="show-grid">
      <Col xs={6}>
        <div className="box-1">
          <span>Last opened in</span>
          <h6>New Delhi, India</h6>
        </div>
      </Col>
      <Col xs={6}>
        <div className="box-1">
          <span>Recent session on</span>
          <h6>
            {clientActivityData.length
              ? ViewActivitiesDate(clientActivityData.at(-1)?.logintime)
              : '-'}
          </h6>
        </div>
      </Col>
      <Col xs={6}>
        <div className="box-1">
          <span>Number of sessions</span>
          <h6>{clientActivityData.length}</h6>
        </div>
      </Col>
      <Col xs={6}>
        <div className="box-1">
          <span>Overall time spend</span>
          <h6>
            {clintActivityFormatTime(
              clientActivityData.reduce((total, item) => total + Number(item.timespent) + 0, 0)
            )}
          </h6>
        </div>
      </Col>
    </Row>
  </Grid>
));
